import ApplicationController, { EVENTO_CONTROLLER_CARGADO } from '../application_controller';

/* global $, blockUIForDownload */
export default class extends ApplicationController {
  connect() {
    const $element = $(this.element);
    const $botonSubmit = $element.find('input.btn-exportar-estadisticas-ensennanza');

    $element.find('#filtro-ensennanza').on(EVENTO_CONTROLLER_CARGADO, (e) => {
      this.selectorCurso = e.detail.controller;

      // Una vez tenemos el selector, revisamos si hay que mostrar u ocultar el input de ciclo
      this.#prepararSeleccionInfantil();

      this.selectorCurso.component.on('option:selected clear', () => {
        $botonSubmit.prop('disabled', !this.selectorCurso.component.tieneSeleccion());
        if (this.selectorCurso.component.tieneSeleccion()) {
          this.#prepararSeleccionInfantil();
        }
      });
    });

    $element.find('form').on('submit', (event) => {
      if (!this.selectorCurso.component.tieneSeleccion()) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      blockUIForDownload($element);
    });
  }

  #prepararSeleccionInfantil() {
    const wrapper = this.#wrapperSelectorNivel();
    const select = wrapper.querySelector('select');
    const seleccion = this.selectorCurso.component.getSelectedPathHash();

    // Limpiamos el select
    [...select].forEach((x) => x.remove());

    if (seleccion.ensennanza?.tipo === 'infantil') {
      const { niveles } = this.selectorCurso.component.model.findByType('ensennanza', seleccion.ensennanza.id).data;

      if (niveles) {
        niveles.forEach((nivel) => {
          const option = document.createElement('option');
          option.value = nivel.id;
          option.text = nivel.nombre;
          select.add(option);
        });
      }

      wrapper.classList.remove('fadeOut');
      wrapper.classList.add('fadeIn');
      wrapper.classList.add('animated');
    } else {
      wrapper.classList.remove('fadeIn');
      wrapper.classList.add('fadeOut');
      wrapper.classList.add('animated');
    }
  }

  #wrapperSelectorNivel() {
    return this.element.querySelector('#selector-nivel');
  }
}
